var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "lds-spinner c-spinner",
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
      },
    },
    [
      _c("g", { attrs: { transform: "rotate(0 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.9166666666666666s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(30 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.8333333333333334s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(60 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.75s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(90 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.6666666666666666s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(120 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.5833333333333334s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(150 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.5s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(180 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.4166666666666667s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(210 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.3333333333333333s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(240 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.25s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(270 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.16666666666666666s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(300 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "-0.08333333333333333s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { transform: "rotate(330 50 50)" } }, [
        _c(
          "rect",
          {
            staticClass: "c-spinner__item",
            attrs: {
              x: "47",
              y: "27",
              rx: "9.4",
              ry: "5.4",
              width: "6",
              height: "6",
              fill: "#000",
            },
          },
          [
            _c("animate", {
              attrs: {
                attributeName: "opacity",
                values: "1;0",
                keyTimes: "0;1",
                dur: "1s",
                begin: "0s",
                repeatCount: "indefinite",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }